<template>
  <div v-if="getProjectId" class="statusReports">
    <div class="titleRow">
      <span id="titleAndProjectName">
        <h1 id="title">{{ $t(localeConsts.statusReportsTitle) }}</h1>
        <span id="projectName"> {{ getProjectName }} </span>
      </span>
    </div>
    <div v-for="(statusReport, index) in allStatusReports" :key="statusReport.id">
      <status-report-entry :title-of-the-card="getTitleOfTheEntry(index)" :status-report-content="statusReport"></status-report-entry>
    </div>
  </div>
</template>

<script>
import StatusReportEntry from './StatusReportEntry.vue'

import moment from 'moment'
import axios from '../../../../axios'

import mapGettersMixin from '../../../mixins/mapGettersMixin'

export default {
  name: 'StatusReports',
  components: {
    StatusReportEntry
  },
  mixins: [mapGettersMixin],
  data() {
    return {
      localeConsts: {
        statusReportsTitle: 'STATUSREPORTS.TITLE'
      },
      statusReportURI: 'status-reports/',
      allStatusReports: []
    }
  },
  computed: {
    startDateOfProjectAsMoment() {
      return moment(this.$store.getters['authentication/getStartDateOfProject'])
    }
  },
  created() {
    this.fetchStatusReports()
  },
  methods: {
    getTitleOfTheEntry(statusReportId) {
      return `\u00A0PW \u00A0${moment(this.allStatusReports[statusReportId].creation_date).diff(this.startDateOfProjectAsMoment, 'weeks')}
        \u00A0-\u00A0 ${moment(this.allStatusReports[statusReportId].creation_date).format('DD.MM.YYYY')}\u00A0\u00A0\u00A0`
    },
    async fetchStatusReports() {
      const responseProjectId = await this.getProjectId
      const params = {
        params: {
          project_id: responseProjectId
        }
      }
      const response = await axios.get(this.statusReportURI, params)
      this.allStatusReports = response.data.sort((a, b) => new Date(b.creation_date) - new Date(a.creation_date))
    }
  }
}
</script>

<style>
.statusReports {
  margin: 0;
  padding: 0;
  width: -webkit-fill-available;
}

.titleRow {
  color: #8b69a9;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

#titleAndProjectName {
  display: flex;
  align-items: baseline;
}

#title {
  color: #8b69a9;
}

#projectName {
  margin-left: 20px;
  font-size: 30px;
}
</style>
